export const about = `
    Hello! My name is Leonardo, but you can call me Leo. 🤓
    <br/> <br/> 
    Passionate about technology and driven by curiosity, I began my journey in software development in 2018. 
    Since then, I have challenged myself daily to learn, grow, and specialize in the tools I work with, always focusing on agile development and delivering high-quality results.
    <br/> <br/>
    My expertise revolves around the JavaScript ecosystem, with a strong focus on React.js, Node.js, and TypeScript. Over the years, I have worked with various technologies, always aiming to build scalable, maintainable, and sustainable solutions, as you can see in my profile below.
`

export const technologies = [
    {
        name: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg"
    },
    {
        name: "Node.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg"
    },
    {
        name: "Vue.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg"
    },
    {
        name: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg"
    },
    {
        name: "TypeScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg"
    },
    {
        name: "Styled C.",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/styledcomponents/styledcomponents-original.svg"
    },
    {
        name: "Material UI",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/materialui/materialui-original.svg"
    },
    {
        name: "Sass",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sass/sass-original.svg"
    }
]